import { useEffect, useMemo } from 'react';
import type { LeadingMarket } from '@/lib/polymark/polymarketEvents';
import { polymarketMarketWsManager } from '@/lib/polymarket/polymarket-websocket/polymarketMarketWsManager';
import { useMarketRealtimeStore } from '@/hooks/store/useMarketRealtimeStore';

function normalizeTokenId(value?: string | null): string {
  return String(value ?? '').trim();
}

export function useMarketRealtimeSubscriptions(markets?: LeadingMarket[] | null) {
  const tokenIds = useMemo(() => {
    const ids = new Set<string>();
    markets?.forEach((market) => {
      const yesToken = normalizeTokenId(market.clob_tokens_id_yes);
      if (yesToken) ids.add(yesToken);
    });
    return Array.from(ids);
  }, [markets]);

  useEffect(() => {
    if (!markets?.length) return;

    const { setMarketSnapshots } = useMarketRealtimeStore.getState();
    setMarketSnapshots(
      markets.map((market) => ({
        marketId: market.market_id,
        conditionId: market.condition_id,
        yesTokenId: market.clob_tokens_id_yes,
        noTokenId: market.clob_tokens_id_no,
        yesPrice: market.outcome_yes_price,
        noPrice: market.outcome_no_price,
        marketClosed: market.market_closed,
        resolvedOutcome: market.resolved_outcome,
      })),
    );
  }, [markets]);

  useEffect(() => {
    if (tokenIds.length === 0) return;

    polymarketMarketWsManager.subscribe(tokenIds);
    return () => {
      polymarketMarketWsManager.release(tokenIds);
    };
  }, [tokenIds]);
}
